<template>
  <div
    class="d-flex justify-sm-center"
    :class="{ 'justify-space-around': !left, 'justify-lg-end': left, 'justify-lg-center': center}">
    <span v-if="text" class="result-text">{{ text }}</span>
    <div v-if="single" class="result-digit single">
      {{ value }}
    </div> <div
      v-else
      class="result-digit"
      v-for="(digit, index) in value"
      :key="index">
      {{ digit }}
    </div>
  </div>
</template>

<script>
import chunk from "lodash/chunk.js";

export default {
  name: "ResultDigitDisplay",
  props: {
    single: {
      type: Boolean,
      default: false
    },
    value: {
      type: String,
      required: true
    },
    group: {
      type: Number,
      default: null
    },
    text: {
      type: String,
      default: ""
    },
    left: {
      type: Boolean,
      default: false
    },
    center: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    chunk
  },
  computed: {
    computedValue() {
      if (this.group) {
        return chunk(this.value.split(""), this.group);
      } else {
        return this.value;
      }
    }
  }
};
</script>

<style scoped lang="scss">
@import "css/variables";
.result-digit {
  color: $white;
  font-family: sans-serif;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: $blue;
  text-shadow: 1px 1px 2px #763d2a;
  padding: 6px;
  font-size: 1.4rem;
  margin: 0 2px;
  font-weight: bold;
  line-height: 40px;
  height: 30px;
  width: 30px;
  border-radius: 50%;
  box-shadow: inset 0 0 3px 0 black;
}
.result-text {
  color: $black;
  font-size: 30px;
  margin-right: 5px;
  width: 60px;
}
</style>
